export function valueIsString(value: any): value is string {
  return typeof value === 'string';
}

export function valueIsNumber(value: any): value is number {
  return typeof value === 'number';
}

export function valueIsInteger(value: any) {
  if (typeof value === 'number') {
    return Number.isInteger(value);
  }

  if (typeof value === 'string') {
    if (!value) return false;
    // Reject strings with leading/trailing whitespace or non-integer characters
    if (value !== value.trim()) return false;
    return /^-?\d+$/.test(value);
  }

  return false;
}

export function valueIsNumberAsString(value: any): boolean {
  if (!valueIsString(value) || value === '') return false;
  const num = Number(value);
  return !Number.isNaN(num) && Number.isFinite(num);
}

export function valueIsDate(value: any): value is Date {
  return value instanceof Date && !isNaN(value.getTime());
}

export function valueIsArrayOfStrings(value: any): value is string[] {
  return Array.isArray(value) && value.every((item) => valueIsString(item));
}

export function valueIsSelectItem(value: any): value is SelectItem<{}> {
  return Object.hasOwn(value, 'value');
}
